<div class="xcal">
  <div class="xcal__nav">
    <button type="button"
            class="xcal__nav-btn"
            [disabled]="!canGoPrev"
            [attr.aria-label]="prevLabel"
            (click)="prevMonth()">‹</button>
    <span class="xcal__month">{{ monthLabel }}</span>
    <button type="button"
            class="xcal__nav-btn"
            [disabled]="!canGoNext"
            [attr.aria-label]="nextLabel"
            (click)="nextMonth()">›</button>
  </div>
  <div class="xcal__grid">
    <span class="xcal__weekday" *ngFor="let label of weekdayLabels">{{ label }}</span>
    <ng-container *ngFor="let week of weeks">
      <button *ngFor="let day of week; trackBy: trackByIso"
              type="button"
              class="xcal__day"
              [class.is-outside]="!day.inMonth"
              [class.is-past]="day.isPast"
              [class.is-today]="day.isToday"
              [class.is-selected]="day.iso === selected"
              [disabled]="day.disabled"
              [attr.aria-pressed]="day.iso === selected"
              [attr.title]="day.iso"
              (click)="select(day)">{{ day.day }}</button>
    </ng-container>
  </div>
</div>
